import React from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import recommendedProductsQuery from './RecommendedProductsQuery.gql';
import { StyledProductRow } from '../../../ContentEditor/ProductRow';
import { ProductRowItem } from '../../../ContentEditor/ProductRowItem';
import { theme } from '../../../Theme'; // Added the missing import statement for the 'theme' object.

const Wrapper = styled('div')`
  margin-bottom: 20px;
`;

const SimilarProducts = ({ product }) => {
  const canonicalCategoryId = product?.canonicalCategory?.id;
  const { data, error } = useQuery(recommendedProductsQuery, {
    variables: {
      id: canonicalCategoryId
    }
  });
  if (!data || error) {
    return null;
  }

  const products = data?.category?.products?.result;

  return (
    <Wrapper>
      <StyledProductRow
        fullWidth={{ value: true }}
        gap={{ value: 20 }}
        padding={{ value: false }}
        cartPage={{ value: false }}
        title={{ value: 'Populära produkter' }}
        link={{ value: data?.category?.primaryRoute?.path }}
        buttonText={{ value: 'Upptäck' }}
        backgroundColor={{ value: `${theme.colors.accent}` }}
        textColor={{ value: `${theme.colors.accentTextColor}` }}
      >
        {products &&
          products?.map((prod, index) => (
            <ProductRowItem key={prod?.id + index} product={prod} />
          ))}
      </StyledProductRow>
    </Wrapper>
  );
};
export default SimilarProducts;
